import React from "react";
import { motion } from "framer-motion";
import { useLang } from "../i18n/LanguageContext";

const COMPANY_BG =
  "https://images.unsplash.com/photo-1619046213817-2d28af9ddaae?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHw0fHxzdGVhbWVkJTIwZmlzaCUyMHJ1c3RpY3xlbnwwfHx8fDE3ODE0MzY3NjV8MA&ixlib=rb-4.1.0&q=85";

export const Company = () => {
  const { t } = useLang();
  return (
    <section
      id="company"
      className="relative py-24 md:py-32 overflow-hidden"
      data-testid="company-section"
    >
      <div className="absolute inset-0">
        <img src={COMPANY_BG} alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-brand-ink/75" />
      </div>

      <div className="relative max-w-[1600px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-8 mb-16">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
            className="col-span-12 md:col-span-7"
          >
            <div className="flex items-center gap-3 mb-6">
              <span className="block w-8 h-px bg-brand-yellow" />
              <span className="font-sans text-[11px] tracking-[0.3em] uppercase text-brand-yellow">
                {t.company.label}
              </span>
            </div>
            <h2 className="font-serif text-5xl md:text-6xl lg:text-7xl text-brand-cream leading-[0.95]">
              {t.company.headline}
              <br />
              <span className="italic text-brand-yellow">{t.company.headline2}</span>
            </h2>
            <p className="mt-8 font-sans text-base md:text-lg text-brand-cream/70 leading-relaxed max-w-2xl">
              {t.company.body}
            </p>
          </motion.div>
        </div>

        <div className="grid grid-cols-12 gap-6">
          {t.company.cards.map((c, i) => (
            <motion.div
              key={c.id}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.8, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
              className="col-span-12 md:col-span-4 group cursor-pointer"
              data-testid={`company-card-${c.id}`}
            >
              <div className="bg-white/5 backdrop-blur-xl border border-white/15 p-8 md:p-10 h-full hover:bg-white/10 hover:border-brand-yellow/40 transition-all duration-500">
                <div className="flex items-start justify-between mb-12">
                  <span className="font-serif text-5xl text-brand-yellow">0{i + 1}</span>
                  <span className="font-sans text-[10px] tracking-[0.3em] uppercase text-brand-cream/40">
                    {c.id}
                  </span>
                </div>
                <h3 className="font-serif text-3xl text-brand-cream group-hover:text-brand-yellow transition-colors">
                  {c.title}
                </h3>
                <p className="mt-3 font-sans text-sm text-brand-cream/60 leading-relaxed">
                  {c.subtitle}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
